import baseApi from './base';

const fetchSysConfig = () =>
  baseApi.request({
    method: 'get',
    url: 'sys-config'
  });

const modifySysConfig = (id, data) =>
  baseApi.request({
    method: 'patch',
    url: `/sys-config/${id}`,
    data
  });

// 获取机器码
const getMacCode = (id, data) =>
  baseApi.request({
    method: 'get',
    url: `/license/mac-code`,
  });

// 获取许可证日期
const getLicenseDate = (id, data) =>
  baseApi.request({
    method: 'get',
    url: `/license/date`,
  });


export {
  fetchSysConfig,
  modifySysConfig,
  getMacCode,
  getLicenseDate
}


// WEBPACK FOOTER //
// ./src/api/sysConfig.js